import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-espresso text-white/80 py-20 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-12 border-b border-white/10 pb-12 mb-12">
        {/* Brand */}
        <div className="col-span-1 md:col-span-1">
          <div className="flex items-center gap-2 mb-6 text-white">
            <img loading="lazy" decoding="async" 
              src="https://static.prod-images.emergentagent.com/jobs/a5f866e2-e980-48dc-baab-bd61582b9a1c/images/664b0963ea78b9ebdb75db1f8ce1af51435c4d4bb40b926db45f6a662822a9d6.png" 
              alt="Resta in Pace" 
              className="h-8 w-8 object-contain"
            />
            <h2 className="text-2xl text-white" style={{ fontFamily: "'Cormorant Garamond', 'Times New Roman', serif", fontStyle: 'italic', fontWeight: 500 }}>
              Resta in Pace
            </h2>
          </div>
          <p className="text-sm leading-relaxed">
            Il portale italiano dedicato alla memoria, ai necrologi e alla cultura del commiato. Professionalità e discrezione al vostro servizio.
          </p>
        </div>

        {/* Servizi */}
        <div>
          <h4 className="text-white font-bold mb-6">Servizi</h4>
          <ul className="space-y-4 text-sm">
            <li>
              <Link to="/necrologi" className="hover:text-primary transition-colors">
                Cerca Necrologio
              </Link>
            </li>
            <li>
              <Link to="/fiori" className="hover:text-primary transition-colors">
                Fiori e Pensieri
              </Link>
            </li>
            <li>
              <Link to="/agenzie" className="hover:text-primary transition-colors">
                Organizzazione Funerali
              </Link>
            </li>
            <li>
              <Link to="/cimiteri" className="hover:text-primary transition-colors">
                Servizi Cimiteriali
              </Link>
            </li>
          </ul>
        </div>

        {/* Risorse */}
        <div>
          <h4 className="text-white font-bold mb-6">Risorse</h4>
          <ul className="space-y-4 text-sm">
            <li>
              <Link to="/blog" className="hover:text-primary transition-colors">
                Blog & Supporto
              </Link>
            </li>
            <li>
              <Link to="/faq" className="hover:text-primary transition-colors">
                Domande Frequenti
              </Link>
            </li>
            <li>
              <Link to="/risorse" className="hover:text-primary transition-colors">
                Guida Pratica
              </Link>
            </li>
            <li>
              <Link to="/biblioteca-documenti" className="hover:text-primary transition-colors">
                Biblioteca PDF
              </Link>
            </li>
            <li>
              <Link to="/contatti" className="hover:text-primary transition-colors">
                Contatti
              </Link>
            </li>
            <li>
              <Link to="/lavora-con-noi" className="hover:text-primary transition-colors">
                Lavora con Noi
              </Link>
            </li>
            <li>
              <Link to="/integrazioni" className="hover:text-primary transition-colors">
                API per Gestionali
              </Link>
            </li>
          </ul>
        </div>

        {/* Contatti */}
        <div>
          <h4 className="text-white font-bold mb-6">Contatti</h4>
          <div className="space-y-4 text-sm">
            <p className="flex items-center gap-3 text-white/80">
              <span className="material-symbols-outlined text-primary">location_on</span>
              D05HX74 Dublin, Ireland
            </p>
            <a href="mailto:info@restainpace.it" className="flex items-center gap-3 hover:text-primary transition-colors">
              <span className="material-symbols-outlined text-primary">mail</span>
              info@restainpace.it
            </a>
            <a href="tel:+390811996634" className="flex items-center gap-3 hover:text-primary transition-colors" data-testid="footer-phone">
              <span className="material-symbols-outlined text-primary">phone</span>
              +39 081 1996 6344
            </a>
            <a href="mailto:supporto@restainpace.it" className="flex items-center gap-3 hover:text-primary transition-colors">
              <span className="material-symbols-outlined text-primary">support_agent</span>
              supporto@restainpace.it
            </a>
            <p className="flex items-center gap-3 text-white/60 text-xs mt-2">
              <span className="material-symbols-outlined text-primary">verified</span>
              PEC: restainpace@pec.it
            </p>
          </div>
        </div>

        {/* Seguici sui Social */}
        <div>
          <h4 className="text-white font-bold mb-6">Seguici</h4>
          <p className="text-sm text-white/70 mb-5 leading-relaxed">
            Storie, supporto e cultura del commiato. Unisciti alla nostra community.
          </p>
          <div className="grid grid-cols-3 gap-3">
            <a
              href="https://www.instagram.com/restainpace.it/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Seguici su Instagram"
              title="Instagram"
              className="w-11 h-11 rounded-full flex items-center justify-center transition-all hover:scale-110"
              style={{ background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)' }}
              data-testid="footer-instagram-link"
            >
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61586631495655"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Seguici su Facebook"
              title="Facebook"
              className="w-11 h-11 rounded-full bg-[#1877F2] flex items-center justify-center hover:bg-[#0e64d8] hover:scale-110 transition-all"
              data-testid="footer-facebook-link"
            >
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@restainpace8"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Seguici su TikTok"
              title="TikTok"
              className="w-11 h-11 rounded-full bg-black flex items-center justify-center hover:bg-gray-800 hover:scale-110 transition-all"
              data-testid="footer-tiktok-link"
            >
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005.8 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1.84-.1z"/>
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/in/resta-in-pace-75797940b/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Seguici su LinkedIn"
              title="LinkedIn"
              className="w-11 h-11 rounded-full bg-[#0A66C2] flex items-center justify-center hover:bg-[#084d96] hover:scale-110 transition-all"
              data-testid="footer-linkedin-link"
            >
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a
              href="https://open.spotify.com/show/033gzN9cc4YbtABRzKkLgS"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Ascolta il podcast su Spotify"
              title="Spotify"
              className="w-11 h-11 rounded-full bg-[#1DB954] flex items-center justify-center hover:bg-[#1ed760] hover:scale-110 transition-all"
              data-testid="footer-spotify-link"
            >
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12C24 5.4 18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z"/>
              </svg>
            </a>
            <a
              href="https://podcasts.apple.com/it/podcast/id1896762533"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Ascolta il podcast su Apple Podcasts"
              title="Apple Podcasts"
              className="w-11 h-11 rounded-full bg-gradient-to-br from-[#A24BFF] to-[#FF2D55] flex items-center justify-center hover:opacity-90 hover:scale-110 transition-all"
              data-testid="footer-apple-podcasts-link"
            >
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 4.5c1.38 0 2.5 1.12 2.5 2.5S13.38 9.5 12 9.5 9.5 8.38 9.5 7s1.12-2.5 2.5-2.5zm0 6.5c2.485 0 4.5 2.015 4.5 4.5v3c0 .55-.45 1-1 1s-1-.45-1-1v-3c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5v3c0 .55-.45 1-1 1s-1-.45-1-1v-3c0-2.485 2.015-4.5 4.5-4.5zm-5.5 4c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1v-3zm10 0c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1v-3z"/>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@restainpace"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Iscriviti al canale YouTube"
              title="YouTube"
              className="w-11 h-11 rounded-full bg-[#FF0000] flex items-center justify-center hover:bg-[#cc0000] hover:scale-110 transition-all"
              data-testid="footer-youtube-link"
            >
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
            <Link
              to="/podcast"
              aria-label="Vai alla pagina del podcast"
              title="Podcast"
              className="w-11 h-11 rounded-full border border-white/20 flex items-center justify-center hover:bg-primary hover:text-espresso hover:scale-110 transition-all"
              data-testid="footer-podcast-link"
            >
              <span className="material-symbols-outlined text-xl">podcasts</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Trust badge: data residency UE + backup */}
      <div className="max-w-7xl mx-auto flex justify-center -mt-2 mb-10" data-testid="footer-eu-data-badge">
        <div className="inline-flex items-center gap-2.5 rounded-full border border-white/15 bg-white/[0.04] px-4 py-2 text-xs text-white/70">
          <span className="material-symbols-outlined text-primary text-base" aria-hidden="true">encrypted</span>
          <span>
            Database e backup nell'<strong className="text-white/90 font-semibold">Unione Europea</strong>
            <span className="hidden sm:inline"> · Eventuali trasferimenti extra-UE solo con garanzie adeguate (SCC)</span>
          </span>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
        <p className="text-center md:text-left max-w-md">
          © {new Date().getFullYear()} Resta in Pace. Tutti i diritti riservati. È vietata la riproduzione anche parziale dei contenuti senza autorizzazione scritta.
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-6">
          <Link to="/privacy-policy" className="hover:text-white transition-colors">
            Privacy Policy
          </Link>
          <Link to="/cookie-policy" className="hover:text-white transition-colors">
            Cookie Policy
          </Link>
          <Link to="/termini-condizioni" className="hover:text-white transition-colors">
            Termini e Condizioni
          </Link>
          <Link to="/child-safety-standards" className="hover:text-white transition-colors">
            Child Safety
          </Link>
          <Link to="/segnala-abuso" className="hover:text-white transition-colors">
            Segnala abuso
          </Link>
          <Link to="/admin-login" className="hover:text-white transition-colors opacity-50 hover:opacity-100">
            Amministrazione
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
